import { toastConfig } from 'lib/reactToastify/config';
import { Id, toast } from 'react-toastify';

import { logError } from 'lib/sentry/logError';

import { IChallengeTimelineItem } from 'features/challenge/ChallengeTimelineItem';
import { useEditChallengesMutation } from 'features/challenge/hooks/mutation/useEditChallenges';
import { useExploreChallengesDialog } from 'features/challenge/hooks/useExploreChallengesDialog';
import { IPlanningDraftSprint } from 'features/planning';

type TUseDraftSprintAddLibraryChallenge = {
  sprint: IPlanningDraftSprint;
  options?: any;
};

export const useDraftSprintAddLibraryChallenge = ({
  sprint,
  options,
}: TUseDraftSprintAddLibraryChallenge) => {
  const { mutateAsync: editChallenges } =
    useEditChallengesMutation<IChallengeTimelineItem>({
      options,
    });

  const onSubmit = async (
    newChallenges: IChallengeTimelineItem | IChallengeTimelineItem[],
    toastId: Id | undefined
  ) => {
    let submitToastId: Id | undefined;
    try {
      if (!toastId) {
        submitToastId = toast.loading(
          'Adding challenges to sprint...',
          toastConfig
        );
      }
      const challenges = Array.isArray(newChallenges)
        ? newChallenges
        : [newChallenges];

      await editChallenges({
        challenges,
        parameters: { addToSprintId: sprint.sprintId },
      });

      !toastId && toast.dismiss(submitToastId);
    } catch (error) {
      logError(error);
    }
  };

  const openExploreChallengesModal = useExploreChallengesDialog(
    // @ts-ignore
    {
      sprint,
      onSubmit,
    }
  );

  return openExploreChallengesModal;
};
